/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-common.validate',
    'cookie-utils',
    'Localizer',
	'window',
	'@thd-olt-global/thd-customer'
],
function(
    pipValidate,
    cookieUtils,
    Localizer,
	window,
	thdCustomer
){

	function Customer() {
		this.dynamicEtaZipCode = null;
		this.quantity = 1;
		this.localStore = {};
	}

	Customer.prototype.getStoreNumber = window.getTHDStoreNo = function getStoreNumber() {
		return cookieUtils.readCookie('THD_NAVLOCALSTORE');
	};

	Customer.prototype.isUserForceLocalized = function isUserForceLocalized() {
		return Localizer.status.isAutoLocalized();
	};

	Customer.prototype.isUserDefaultLocalized = function isUserDefaultLocalized() {
		return Localizer.status.isDefaultLocalized();
	};

	Customer.prototype.localizedZipCode = function localizedZipCode() {
		var store = Localizer.getLocalizedStore();
		return store ? store.zipcode : '';
	};

	Customer.prototype.getApiThrottleOverride = function getApiThrottleOverride() {
		if (window.location && window.location.href) {
			if (window.location.href.indexOf("overrideApiThrottle=1") > -1) {
				return 'overrideApiThrottle=1';
			} else if (window.location.href.indexOf("overrideApiThrottle=0") > -1) {
				return 'overrideApiThrottle=0';
			} else {
				return null;
			}
		}
		return null;
	};

	// TODO: Reconcile this approach with the DETA zip stored approach above and decide which
	// to keep.  Throwing the deta stored code into the methods makes it test-able, but less
	// readable.
	Customer.prototype.getCheckAvailabilityZipCode = function getCheckAvailabilityZipCode() {
		var zipCode = '';
		var aolZipCode = cookieUtils.readCookie("THD_AOL");
		if (aolZipCode) {
			zipCode = aolZipCode.split(",")[0];
			if (!pipValidate.validateZipCode(zipCode)) {
				zipCode = '';
			}
		}
		return zipCode;
	};

	Customer.prototype.setDynamicEtaZipCode = function setDynamicEtaZipCode(dynamicEtaZipCode) {
        this.dynamicEtaZipCode = dynamicEtaZipCode;
	};

	Customer.prototype.getNumberItemsInCart = function getNumberItemsInCart() {
		return cookieUtils.getTHDNumberItemsInCart();
	}

  Customer.prototype.hasUserID = function hasUserID() {
    return !!thdCustomer.default.userID;
  }

	Customer.prototype.isLoggedIn = function isLoggedIn() {
		return thdCustomer.default.isLoggedIn;
	}

  Customer.prototype.isAuthUser = function isAuthUser() {
    return thdCustomer.default.isLoggedIn;
  }

  Customer.prototype.hasUserSession = function hasUserSession() {
    return !!thdCustomer.default.token;
  }

  Customer.prototype.isTwoFactorAuth = function isTwoFactorAuth() {
    return !!(cookieUtils.readCookie('IC_ROADS'));
  }



	return Customer;

});

}.call(window));